import React, { useMemo, useRef, useState } from 'react';

interface Props {
  value: string;
  options: string[];
  onChange: (value: string) => void;
  placeholder?: string;
  inputId?: string;
}

// Free-text input with autocomplete from existing values. New values are accepted.
const SectionCombobox: React.FC<Props> = ({ value, options, onChange, placeholder, inputId }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const filtered = useMemo(() => {
    const q = value.trim().toLowerCase();
    if (!q) return options;
    return options.filter(o => o.toLowerCase().includes(q));
  }, [options, value]);

  return (
    <div ref={containerRef} style={{ position: 'relative' }}
      onBlur={(e) => {
        if (!containerRef.current?.contains(e.relatedTarget as Node)) {
          setOpen(false);
        }
      }}
    >
      <input
        id={inputId}
        type="text"
        className="resus-admin__input"
        value={value}
        placeholder={placeholder}
        onFocus={() => setOpen(true)}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
      />
      {open && filtered.length > 0 && (
        <ul style={{
          position: 'absolute',
          top: '100%',
          insetInlineStart: 0,
          right: 0,
          background: 'white',
          border: '1px solid #DDE5EE',
          borderRadius: 8,
          marginTop: 4,
          padding: 4,
          listStyle: 'none',
          zIndex: 50,
          maxHeight: 220,
          overflowY: 'auto',
          boxShadow: '0 4px 12px rgba(16,60,110,0.08)'
        }}>
          {filtered.map(opt => (
            <li key={opt}>
              <button
                type="button"
                style={{
                  background: 'transparent',
                  border: 'none',
                  width: '100%',
                  textAlign: 'inherit',
                  padding: '6px 10px',
                  borderRadius: 6,
                  cursor: 'pointer'
                }}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => { onChange(opt); setOpen(false); }}
              >
                {opt}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SectionCombobox;
